// initialMessages.js

/**
 * Generates the initial messages for the chat.
 *
 * @param {function} t - The translation function from react-i18next.
 * @returns {Array} - An array of initial message objects.
 */
export const getInitialMessages = (t) => [
    {
        id: 'welcome',
        type: 'assistant',
        text: t('chat.welcomeMessage'),
    },
    {
        id: 'useChat',
        type: 'suggestion',
        text: t('chat.suggestions.useChat'),
    },
    {
        id: 'contactMunicipality',
        type: 'suggestion',
        text: t('chat.suggestions.contactMunicipality'),
    },
];
